export const EVENT_NAMES_ECOMMERCE = {
  ADD_TO_CART: 'eCommerce - Add to Cart',
  CHECKOUT: 'eCommerce - Checkout',
  PURCHASE: 'eCommerce - Purchase',
  REFUND: 'eCommerce - Refund',
  REMOVE_FROM_CART: 'eCommerce - RemoveFromCart',
  VIEW_DETAIL: 'eCommerce - ViewDetail',
};
